module.exports = __webpack_public_path__ + "media/CN_007.5cd46b12.mp3";